import { create } from 'zustand';

const useAuthStore = create((set) => ({
  // Состояние
  isAuthenticated: !!localStorage.getItem('token'),
  
  // Действия
  login: (token) => {
    localStorage.setItem('token', token);
    set({ isAuthenticated: true });
    window.location.href = '/documents';
  },
  
  logout: () => {
    localStorage.removeItem('token');
    set({ isAuthenticated: false });
    window.location.href = '/auth';
  },
  
  checkAuth: () => {
    const token = localStorage.getItem('token');
    const isAuth = !!token;
    set({ isAuthenticated: isAuth });
    return isAuth;
  }
}));

export default useAuthStore; 
